<template>
  <div class="px-0 pb-0 card-body">
    <div v-if="loading && filteredData.length === 0" class="text-center py-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2">Loading TBS EPON ONU data...</p>
    </div>
    <div class="table-responsive" v-else-if="filteredData.length > 0">
      <div class="card mb-4">
        <div class="card-body px-0 pt-0 pb-2 invoice">
          <div class="table-responsive p-0">
            <table class="table align-items-center mb-0">
              <thead>
                <tr>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Port Interface
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    ONU ID
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    PPPOE ID
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    MAC Address
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Port
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Alive Time
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Last Reg Time
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Last Dereg Time
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Dereg Reason
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(onu, index) in filteredData" :key="index">
                  <td class="align-middle text-center text-sm">
                    {{ onu.port_interface || onu.interface_name || 'N/A' }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ onu.onuId || onu.onu_id || 'N/A' }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    <span v-if="onu.PPPOE_ID === 'Loading...'">
                      <span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                    </span>
                    <span v-else>
                      {{ onu.PPPOE_ID ?? 'N/A' }}
                    </span>
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ formatMacAddress(onu.mac) }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ onu.port || 'N/A' }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ onu.aliveTime || 'N/A' }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ formatDateTime(onu.lastRegTime) }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ formatDateTime(onu.lastDeregTime) }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ formatDeregReason(onu.lastDeregReason) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <Skalaton />
    </div>
  </div>
</template>

<script>
import Skalaton from "@/components/Skalaton.vue";

export default {
  name: "TbsEponTable",
  components: {
    Skalaton
  },
  props: {
    loading: Boolean,
    filteredData: {
      type: Array,
      default: () => []
    },
    sortKey: String,
    sortOrder: String
  },
  methods: {
    formatDateTime(datetime) {
      if (!datetime || datetime.includes('2000-01-01')) return 'N/A';
      return datetime;
    },
    formatMacAddress(mac) {
      if (!mac) return 'N/A';
      // Convert formats like 4CAE.1C24.0DB0 to 4c:ae:1c:24:0d:b0
      return mac.toLowerCase()
        .replace(/[^a-f0-9]/g, '')
        .match(/.{1,2}/g)
        .join(':');
    },
    formatDeregReason(reason) {
      if (!reason) return 'N/A';
      return reason.split('-').map(word => 
        word.charAt(0).toUpperCase() + word.slice(1)
      ).join(' ');
    }
  }
};
</script>

<style scoped>
.table th {
  padding: 12px 24px !important;
}

.sort-icon {
  margin-left: 5px;
}

.asc::after {
  content: "▲";
}

.desc::after {
  content: "▼";
}
</style>

